import React from 'react';
import {Link as RouterLink} from 'react-router-dom';
import { Container, Typography, Box } from '@mui/material';

export default function Footer() {
  return (
    <Box component="footer"
      sx={{ width: '100%', minWidth: '1300px', boxSizing: 'border-box', backgroundColor: '#000', color: '#fff', py: 4,
        mt: 'auto', borderTop: '2px solid #41FBFF', display: 'flex', justifyContent: 'flex-start' }}>
      <Container maxWidth={false} disableGutters
        sx={{ width: '1350px', minWidth: '1350px', maxWidth: '1350px', ml: 'max(0px, calc((100vw - 1350px) / 2))',
          mr: 0, flexShrink: 0, boxSizing: 'border-box', }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', width: '1325px', alignItems: 'start', 
          marginLeft: '20px', display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "nowrap",
           gap: 2, }}>
          <Box sx={{ textAlign: 'left' }}>
            <Typography variant="h6" sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 700 }}>
              Digital Operating
            </Typography>
            <Typography variant="body2" sx={{ fontFamily: 'Inter, sans-serif', }}>
              The Next Era of Subsurface Analysis
            </Typography>
          </Box>
          <Box sx={{ textAlign: 'center', display: "flex", gap: 4, flexWrap: "nowrap" }}>
            <Box>
              <Typography variant="subtitle2" sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, mb: 1 }}>
                Services
              </Typography>
              <Typography component={RouterLink} to="/adval_taxes" variant="body2" display='block'
               sx={{ fontFamily: 'Inter, sans-serif', color: '#a4fdffff', mb: 0.5, textDecoration: 'none' }}>
                Tax Evaluation
              </Typography>
              <Typography component={RouterLink} to="/digitization" variant="body2" display='block'
               sx={{ fontFamily: 'Inter, sans-serif', color: '#a4fdffff', mb: 0.5, textDecoration: 'none' }}>
                Log Digitization
              </Typography>
              <Typography component={RouterLink} to="/digitization#geotech-services" variant="body2" display='block'
               sx={{ fontFamily: 'Inter, sans-serif', color: '#a4fdffff', textDecoration: 'none' }}>
                Consulting
              </Typography>
            </Box>      
          </Box>
          <Box sx={{ textAlign: 'right', display: "flex", gap: 4, flexWrap: "nowrap" }}>                  
            <Box>
              <Typography variant="subtitle2" sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, mb: 1 }}>
                Company
              </Typography>
              <Typography  variant="body2" sx={{ fontFamily: 'Inter, sans-serif', color: '#a4fdffff', mb: 0.5 }}>
                About Us
              </Typography>
              <Typography variant="body2" sx={{ fontFamily: 'Inter, sans-serif', color: '#a4fdffff', mb: 0.5 }}>
                Our Team
              </Typography>
              <Typography variant="body2" sx={{ fontFamily: 'Inter, sans-serif', color: '#a4fdffff' }}>
                Contact
              </Typography>
            </Box>
          </Box>
        </Box>        
        <Box mt={3} pt={2} borderTop="1px solid #333" display="flex" justifyContent="space-between"
          alignItems="center" flexWrap="nowrap">
          <Typography variant="body2" sx={{ fontFamily: 'Inter, sans-serif', marginLeft: '20px' }}>
            © {new Date().getFullYear()} Digital Operating. All rights reserved.
          </Typography>
          <Typography variant="body2" sx={{ fontFamily: 'Inter, sans-serif' }}>
            Powered by cutting-edge geoscience technology
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
